export default "__VITE_ASSET__CzLJaq9f__"